module.exports = __webpack_public_path__ + "img/seq14.43803d60.png";